import { KpiBase } from "./kpiBase";

export class Kpi3View {
  constructor(className) {
    const wrap = document.querySelector(`.${className} .table-body .col`);
    this._view = new swim.HtmlAppView(wrap);
    this._elemList = [];

    this._headerValue = swim.HtmlView.fromNode(document.querySelector(`.${className} header h3`));
    this._headerValue.text('--');

    this._linkVehicles = null;
    this._vehicles = {};

    this._textColor = '#fff';

    this.init();
  }

  set title(string) {
    this._headerValue.text(`${string}`);
  }

  set textColor(value) {
    this._textColor = value;
  }

  init() {
    for(let i = 0; i < 2000; i++) {
      this.createRow();
    }

    // this.linkVehicles();
  }

  linkVehicles(nodeRef) {
    this._linkVehicles = nodeRef.downlinkMap().laneUri('vehicles')
      .didUpdate(this.updateData.bind(this))
      .open();
  }

  unlinkVehicles() {
    if(this._linkVehicles) {
      this._linkVehicles.close();
      this._linkVehicles = null;
    }

    for(const index in this._elemList) {
      const elem = this._elemList[index];
      elem.display = false;
      elem.id = null;
      elem.parent.display('none');
    }

    this._vehicles = {};
  }

  updateData(k, v) {
    if(!v.toAny()) { return; }

    const key = k.stringValue();
    let vehicle = this._vehicles[key];
    if(!vehicle) {
      vehicle = this._vehicles[key] = {};
    }

    vehicle.dirty = true;
    vehicle.id = v.get('id').stringValue();
    vehicle.reportTime = v.get('reportTime').numberValue(0);

    // this.render();
  }

  render() {
    let dataKey = Object.keys(this._vehicles).sort((a, b)=> {
      const aTime = new Date(this._vehicles[a].reportTime);
      const bTime = new Date(this._vehicles[b].reportTime);
      return bTime - aTime;
    });

    const sortLen = dataKey.length;
    if(this._elemList.length < sortLen) {
      for(let i = 0; i < sortLen - this._elemList.length; i++) {
        this.createRow();
      }
    }

    for(const index in this._elemList) {
      const elem = this._elemList[index];
      const obj = this._vehicles[dataKey[index]];

      if(obj) {

        if(elem.id != obj.id && obj.dirty) {
          elem.display = true;
          elem.id = obj.id;
          elem.parent.display('flex').color(this._textColor);
          elem.col[0].text(`${obj.id}`);
          elem.col[1].text('--');
          elem.col[2].text(`${this.dateFormat(obj.reportTime)}`);
        }

      } else {
        if(elem.display) {
          elem.display = false;
          elem.id = null;
          elem.parent.display('none');
        } else {
          break;
        }
      }
    }

    // document.querySelector('.today-tag .status').innerHTML = `${sortLen}`;
  }

  createRow() {
    const row = swim.HtmlView.create('div').className('row').display('none');
    // .color('#F9F070');
    const id = row.append('div').className('col col-5');
    const distance = row.append('div').className('col col-3');
    const time = row.append('div').className('col col-4');

    const obj = {id:null, data: null, display: false, parent: row, col: [id, distance, time] };
    this._elemList.push(obj);
    this._view.append(row);
  }

  dateFormat(timestamp) {
    const time = new Date(timestamp); // LocalTime zone

    // Change it back to the timestamp TimeZone
    time.setMinutes(time.getMinutes()+time.getTimezoneOffset());

    return time.toLocaleDateString('en-US', {
      hour12: false,
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  }

}
